<template>
    <validation-observer ref="form" v-slot="{ handleSubmit, errors, meta }">
        <b-form @submit.prevent="handleSubmit(_, save)">
            <b-row>
                <b-col md="6">
                    <validation-provider name="rental_property_id" v-slot="{ handleChange }" rules="required">
                        <form-select
                            label="Property:"
                            v-model="values.rental_property_id"
                            :options="propertyOptions"
                            :error="errors.rental_property_id"
                            @input="handleChange"
                        ></form-select>
                    </validation-provider>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <label>Commission:</label>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6">
                    <grid
                        ref="grid"
                        :is-auto-height="true"
                        :is-search="false"
                        :get-row-id="getRowId"
                        :row-data="commissionsDetails"
                        :column-defs="columnDefs"
                        :style="{ marginBottom: '1rem' }"
                    ></grid>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6">
                    <validation-provider name="commission_calculation" v-slot="{ handleChange }" rules="required">
                        <form-select
                            label="Mgmt Commission Calculation:"
                            v-model="values.commission_calculation"
                            :options="commissionCalculationOptions"
                            :error="errors.commission_calculation"
                            @change="handleChange"
                        ></form-select>
                    </validation-provider>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group>
                        <form-switch v-model="values.allow_owner_will_clean" />
                        <label>Allow Owner Cleans</label>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group>
                        <form-switch
                            :value="values.assess_channel_commissions_to_owner"
                            @input="handleAccessChannelCommissionsToOwnerChange"
                        />
                        <label>Assess Channel Commissions to Owner</label>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group>
                        <form-switch
                            :value="values.include_lodgix_commissions_in_channel_commissions"
                            @input="handleIncludeLodgixCommissionsInChannelCommissions"
                        />
                        <label>Include Lodgix Fees in Channel Commissions</label>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <b-form-group>
                        <form-switch v-model="values.display_guest_name_in_owner_statement" />
                        <label>Display Guest Name in Owner Statement</label>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <b-form-group>
                        <form-switch v-model="values.pass_cancellation_fees_to_owner" />
                        <label>Pass cancellation fees (revenue) to owners</label>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="values.pass_cancellation_fees_to_owner">
                <b-col md="6">
                    <validation-provider name="pass_cancellation_fees_to_owner_mode" v-slot="{ handleChange }">
                        <form-select
                            v-model="values.pass_cancellation_fees_to_owner_mode"
                            :options="cancellationFeeOptions"
                            :error="errors.pass_cancellation_fees_to_owner_mode"
                            @change="handleChange"
                        ></form-select>
                    </validation-provider>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6">
                    <validation-provider name="rental_fee_name" v-slot="{ handleChange }" rules="required">
                        <form-input
                            label="Rental Fee:"
                            placeholder="Rental Fee Name"
                            v-model="values.rental_fee_name"
                            :error="errors.rental_fee_name"
                            @input="handleChange"
                        ></form-input>
                    </validation-provider>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="4">
                    <validation-provider name="rental_fee">
                        <form-input
                            placeholder="Rental Fee"
                            :value="values.rental_fee"
                            @input="handleRentalFeeChange"
                            :error="errors.rental_fee"
                        ></form-input>
                    </validation-provider>
                </b-col>
                <b-col md="2">
                    <validation-provider
                        name="rental_fee_is_flat"
                        v-slot="{ handleChange }"
                        rules="required:allowFalse"
                    >
                        <form-select
                            v-model="values.rental_fee_is_flat"
                            :options="flatOptions"
                            :error="errors.rental_fee_is_flat"
                            @change="handleChange"
                        ></form-select>
                    </validation-provider>
                </b-col>
            </b-row>
            <b-row v-if="!values.rental_fee_is_flat">
                <b-col>
                    <b-form-group>
                        <form-switch v-model="values.rental_fee_include_taxes" />
                        <label>Include Taxes</label>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row v-if="!values.rental_fee_is_flat">
                <b-col>
                    <b-form-group>
                        <form-switch v-model="values.rental_fee_include_fees" />
                        <label>Include Fees</label>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6">
                    <validation-provider name="cleaning_fee_name" v-slot="{ handleChange }" rules="required">
                        <form-input
                            label="Cleaning Fee:"
                            placeholder="Cleaning Fee Name"
                            v-model="values.cleaning_fee_name"
                            :error="errors.cleaning_fee_name"
                            @input="handleChange"
                        ></form-input>
                    </validation-provider>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="4">
                    <validation-provider name="cleaning_fee">
                        <form-input
                            placeholder="Cleaning Fee"
                            :value="values.cleaning_fee"
                            @input="handleCleaningFeeChange"
                            :error="errors.cleaning_fee"
                        ></form-input>
                    </validation-provider>
                </b-col>
                <b-col md="2">
                    <validation-provider
                        name="cleaning_fee_is_flat"
                        v-slot="{ handleChange }"
                        rules="required:allowFalse"
                    >
                        <form-select
                            v-model="values.cleaning_fee_is_flat"
                            :options="flatOptions"
                            :error="errors.cleaning_fee_is_flat"
                            @change="handleChange"
                        ></form-select>
                    </validation-provider>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="6">
                    <validation-provider name="other_fee_name" v-slot="{ handleChange }" rules="required">
                        <form-input
                            label="Other Fee:"
                            placeholder="Other Fee"
                            v-model="values.other_fee_name"
                            :error="errors.other_fee_name"
                            @input="handleChange"
                        ></form-input>
                    </validation-provider>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="4">
                    <validation-provider name="other_fee">
                        <form-input
                            placeholder="Other Fee"
                            :value="values.other_fee"
                            @input="handleOtherFeeChange"
                            :error="errors.other_fee"
                        ></form-input>
                    </validation-provider>
                </b-col>
                <b-col md="2">
                    <validation-provider name="other_fee_is_flat" rules="required:allowFalse">
                        <form-select
                            v-model="values.other_fee_is_flat"
                            :options="flatOptions"
                            :error="errors.other_fee_is_flat"
                        ></form-select>
                    </validation-provider>
                </b-col>
            </b-row>
            <b-button class="mt-4 mb-4" type="submit" variant="primary" :disabled="saveLoading">
                Save
            </b-button>
        </b-form>
    </validation-observer>
</template>

<script>
import { mapGetters } from 'vuex';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import sortBy from 'lodash/sortBy';
import { formatResponseError } from '../../../../utils/api';
import API from '../../../../api';
import {
    CANCELLATION_FEE_GROSS,
    CANCELLATION_FEE_NET,
    COMMISSION_CALCULATION_GROSS,
    COMMISSION_CALCULATION_NET,
    COMMISSION_CALCULATION_GROSS_LESS_CC,
    COMMISSION_CALCULATION_NET_LESS_CC,
    COMMISSION_CALCULATION_MAPPING,
    COMMISSION_CALCULATIONS,
    LIMITED_COMMISSION_CALCULATIONS,
} from '../../../../constants';
import Grid from '../../../generic/grid/grid.vue';
import FormInput from '../../../generic/form-input/form-input.vue';
import FormSelect from '../../../generic/form-select/form-select.vue';
import FormSwitch from '../../../generic/form-switch/form-switch.vue';

export default {
    name: 'OwnerPropertyForm',
    components: {
        Grid,
        FormInput,
        FormSelect,
        FormSwitch,
    },
    props: {
        initialValues: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        ...mapGetters('owner', ['metadata']),
        commissionsDetails() {
            const total = this.values.commissions_details.reduce(
                (commission, details) => commission + Number(details.commission),
                0
            );
            return [
                ...this.values.commissions_details,
                {
                    position: null,
                    commission: isNil(total) || isNaN(total) ? '' : this.stringifyNumber(total),
                },
            ];
        },
        propertyOptions() {
            const properties = [];
            if (this.initialValues.name && this.initialValues.rental_property_id) {
                properties.push({
                    value: this.initialValues.rental_property_id,
                    text: this.initialValues.name,
                });
            } else {
                properties.push({ value: null, text: 'Please choose a property' });
            }
            this.availableProperties.forEach((property) => {
                properties.push({
                    value: property.id,
                    text: property.name,
                });
            });
            return properties;
        },
        teamMemberOptions() {
            return [
                { value: null, text: 'Not Assigned' },
                ...this.activeTeamMembers.map((e) => ({
                    value: e.id,
                    text: e.name,
                })),
            ];
        },
        flatOptions() {
            return [
                { value: true, text: 'Fixed' },
                { value: false, text: 'Percentage' },
            ];
        },
        cancellationFeeOptions() {
            return [
                {
                    value: CANCELLATION_FEE_GROSS,
                    text: 'Gross Cancellation Fee (property manager pays channel fee)',
                },
                {
                    value: CANCELLATION_FEE_NET,
                    text: 'Net Cancellation Fee (owner revenue reduced by amount of channel fee)',
                },
            ];
        },
        commissionCalculationOptions() {
            const calculations = this.values.assess_channel_commissions_to_owner
                ? COMMISSION_CALCULATIONS
                : LIMITED_COMMISSION_CALCULATIONS;

            return calculations.map((calculation) => ({
                value: calculation,
                text: COMMISSION_CALCULATION_MAPPING[calculation],
            }));
        },
    },
    mounted() {
        (async () => {
            this.loading = true;

            try {
                await Promise.all([this.fetchAvailableProperties(), this.fetchTeamMembers(), this.fetchMetadata()]);
                this.values = this.getInitialValues();
                this.$refs.form.setValues(this.values);
            } finally {
                this.loading = false;
            }
        })();
    },
    data() {
        return {
            loading: false,
            saveLoading: false,
            availableProperties: [],
            activeTeamMembers: [],
            values: this.getInitialValues(),
            columnDefs: [
                {
                    headerName: '',
                    sortable: false,
                    minWidth: 120,
                    maxWidth: 120,
                    valueGetter: ({ data }) =>
                        !isNil(data.position) ? (data.position === 0 ? 'Default' : `Comm. #${data.position}`) : '',
                },
                {
                    headerName: 'Agent',
                    sortable: false,
                    field: 'team_member_id',
                    minWidth: 200,
                    cellRenderer: ({ data, value }) => {
                        if (isNil(data.position)) {
                            return 'Total Commission:';
                        } else if (data.position === 0 && !data.agent_name) {
                            return '';
                        } else if (!value) {
                            return 'Not Assigned';
                        }
                        const teamMember = this.activeTeamMembers.find((e) => e.id === value);
                        return (teamMember && teamMember.name) || data.agent_name || 'Not Assigned';
                    },
                    cellStyle: ({ data }) => {
                        if (isNil(data.position)) {
                            return { textAlign: 'right' };
                        }
                    },
                    editable: ({ data }) => !!data.position,
                    cellClass: ({ data }) => (!!data.position ? 'text-primary lx-editable-cell' : ''),
                    cellEditor: 'selectCellEditor',
                    cellEditorParams: () => ({
                        options: this.teamMemberOptions,
                    }),
                    valueSetter: ({ newValue, data }) => {
                        data.team_member_id = newValue;
                        return true;
                    },
                },
                {
                    type: 'editableColumn',
                    headerName: 'Value',
                    sortable: false,
                    field: 'commission',
                    cellEditorParams: { isDecimal: true, select: true },
                    editable: ({ data }) => !isNil(data.position),
                    cellClass: ({ data }) => (!isNil(data.position) ? 'text-primary lx-editable-cell' : ''),
                    valueSetter: ({ newValue, data }) => {
                        data.commission = newValue;
                        return true;
                    },
                },
                {
                    headerName: 'Value Type',
                    sortable: false,
                    valueGetter: () => this.values.is_flat,
                    cellRenderer: () => (this.values.is_flat ? 'Fixed' : 'Percentage'),
                    editable: ({ data }) => isNil(data.position),
                    cellClass: ({ data }) => (isNil(data.position) ? 'text-primary lx-editable-cell' : ''),
                    cellEditor: 'selectCellEditor',
                    cellEditorParams: () => ({
                        options: this.flatOptions,
                    }),
                    valueSetter: ({ newValue }) => {
                        this.values.is_flat = newValue;
                        return true;
                    },
                },
            ],
        };
    },
    methods: {
        getRowId(item) {
            return item.data.position;
        },
        getInitialCommissionsDetails() {
            let commissionsDetails = this.initialValues.commissions_details || [];
            const positionIDs = new Set(commissionsDetails.map((cd) => cd.position));

            if (!positionIDs.has(1)) {
                commissionsDetails.push({
                    position: 1,
                    team_member_id: null,
                    commission: 0,
                });
            }
            if (!positionIDs.has(2)) {
                commissionsDetails.push({
                    position: 2,
                    team_member_id: null,
                    commission: 0,
                });
            }

            commissionsDetails = sortBy(commissionsDetails, 'position');

            if (positionIDs.has(0)) {
                const defaultCommissionIndex = commissionsDetails.findIndex((cd) => cd.position === 0);
                commissionsDetails.push(commissionsDetails.splice(defaultCommissionIndex, 1)[0]);
            } else {
                commissionsDetails.push({
                    position: 0,
                    team_member_id: null,
                    commission: 0,
                });
            }

            return commissionsDetails.reduce(
                (result, commissionDetails) => [
                    ...result,
                    {
                        ...commissionDetails,
                        commission: this.stringifyNumber(commissionDetails.commission),
                    },
                ],
                []
            );
        },
        getInitialValues() {
            return {
                id: this.initialValues.id || null,
                owner_id: this.initialValues.owner_id || null,
                rental_property_id: this.initialValues.rental_property_id || null,
                commission_calculation: this.initialValues.commission_calculation || COMMISSION_CALCULATION_GROSS,
                pass_cancellation_fees_to_owner_mode:
                    this.initialValues.pass_cancellation_fees_to_owner_mode || CANCELLATION_FEE_GROSS,
                allow_owner_will_clean: isNil(this.initialValues.allow_owner_will_clean)
                    ? true
                    : this.initialValues.allow_owner_will_clean,
                assess_channel_commissions_to_owner: this.initialValues.assess_channel_commissions_to_owner || false,
                include_lodgix_commissions_in_channel_commissions:
                    this.initialValues.include_lodgix_commissions_in_channel_commissions || false,
                display_guest_name_in_owner_statement:
                    this.initialValues.display_guest_name_in_owner_statement || false,
                pass_cancellation_fees_to_owner: this.initialValues.pass_cancellation_fees_to_owner || false,
                is_flat: this.initialValues.is_flat || false,
                rental_fee: this.stringifyNumber(this.initialValues.rental_fee || 0),
                rental_fee_is_flat: this.initialValues.rental_fee_is_flat || false,
                rental_fee_include_taxes: isNil(this.initialValues.rental_fee_include_taxes)
                    ? true
                    : this.initialValues.rental_fee_include_taxes,
                rental_fee_include_fees: this.initialValues.rental_fee_include_fees || false,
                rental_fee_name:
                    this.initialValues.rental_fee_name ||
                    get(this.metadata, 'manager_settings.rental_fee_name') ||
                    'Rental Fee',
                cleaning_fee: this.stringifyNumber(this.initialValues.cleaning_fee || 0),
                cleaning_fee_is_flat: this.initialValues.cleaning_fee_is_flat || false,
                cleaning_fee_name:
                    this.initialValues.cleaning_fee_name ||
                    get(this.metadata, 'manager_settings.cleaning_fee_name') ||
                    'Cleaning Fee',
                other_fee: this.stringifyNumber(this.initialValues.other_fee || 0),
                other_fee_is_flat: this.initialValues.other_fee_is_flat || false,
                other_fee_name:
                    this.initialValues.other_fee_name ||
                    get(this.metadata, 'manager_settings.other_fee_name') ||
                    'Other Fee',
                commissions_details: this.getInitialCommissionsDetails(),
            };
        },
        getPreparedValues() {
            return {
                ...this.values,
                commissions_details: this.values.commissions_details.map((cd) => ({
                    team_member_id: cd.team_member_id,
                    position: cd.position,
                    commission: cd.commission,
                })),
            };
        },
        stringifyNumber(number) {
            const float = parseFloat(number);

            if (float === 0) {
                return '0.00';
            } else if (float) {
                return float.toFixed(2).toString();
            }

            return '';
        },
        async fetchAvailableProperties() {
            try {
                const response = await API.get('/app/property/property/available/');
                this.availableProperties = response.data;
            } catch (err) {
                this.errorToast({ text: 'Could not load available property data.' });
            }
        },
        async fetchTeamMembers() {
            try {
                const response = await API.get('/app/team-member/team-member/current-active/');
                this.activeTeamMembers = response.data;
            } catch (err) {
                this.errorToast({ text: 'Could not load active team member data.' });
            }
        },
        async fetchMetadata() {
            try {
                await this.$store.dispatch('owner/fetchMetadata', { force: true });
            } catch (err) {
                this.errorToast({ text: 'Could not load metadata.' });
            }
        },
        async update() {
            const response = await API.patch(`/app/owner/owner-property/${this.values.id}/`, this.getPreparedValues());
            this.fetchAvailableProperties();
            this.fetchMetadata();
            this.$emit('success', response.data);
            this.successToast({ text: 'Property was successfully updated.' });
        },
        async create() {
            const response = await API.post(`/app/owner/owner-property/`, this.getPreparedValues());
            this.fetchAvailableProperties();
            this.fetchMetadata();
            this.$emit('success', response.data);
            this.successToast({ text: 'Property was successfully created.' });
        },
        async save() {
            this.saveLoading = true;

            try {
                await (this.initialValues.id ? this.update() : this.create());
            } catch (err) {
                const { generic, fields } = formatResponseError(err);

                if (generic) {
                    this.errorToast({ text: generic });
                } else {
                    this.errorToast({ text: 'Something went wrong while saving property.' });
                }
                if (!isEmpty(fields)) {
                    this.$refs.form.setErrors(fields);
                }
            } finally {
                this.saveLoading = false;
            }
        },
        handleAccessChannelCommissionsToOwnerChange(giveAccess) {
            this.values.assess_channel_commissions_to_owner = giveAccess;
            if (!giveAccess && this.values.commission_calculation === COMMISSION_CALCULATION_GROSS_LESS_CC) {
                this.values.commission_calculation = COMMISSION_CALCULATION_GROSS;
            } else if (!giveAccess && this.values.commission_calculation === COMMISSION_CALCULATION_NET_LESS_CC) {
                this.values.commission_calculation = COMMISSION_CALCULATION_NET;
            }
        },
        handleIncludeLodgixCommissionsInChannelCommissions(value) {
            this.values.include_lodgix_commissions_in_channel_commissions = value;
        },
        handleRentalFeeChange(fee) {
            this.values.rental_fee = fee === '' ? null : fee;
        },
        handleCleaningFeeChange(fee) {
            this.values.cleaning_fee = fee === '' ? null : fee;
        },
        handleOtherFeeChange(fee) {
            this.values.other_fee = fee === '' ? null : fee;
        },
    },
    watch: {
        initialValues() {
            this.values = this.getInitialValues();
        },
    },
};
</script>
